import React from 'react'
import { View, ScrollView, Image, StyleSheet, Linking } from 'react-native'
import { txt } from '../../../locales/i18n'
import { CustomText } from '../../text/StyledText'
import Fontsizes from '../../../constants/Fontsizes'
import { ImageHighlight } from '../../images/ImageHighlight'
import NormalIcon from '../../icons/NormalIcon'
import IconNames from '../../../constants/IconNames'
import Colors from '../../../constants/Colors'
import Layout from '../../../constants/Layout'
import TxtTMD from '../../../constants/TxtTMD'
import PageTitle from '../../tags/PageTitle'
import { SpacingStyles } from '../../../styles'
import CustomPressable from "../../pressables/CustomPressable"

export default class Sponsors extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <ScrollView style={styles.scrollContainer}>
        <PageTitle title={TxtTMD.sponsors.title[TxtTMD.lang]} />
        <View style={styles.container}>
          <CustomText font={'bold'} style={styles.marginBottom12}>
            {txt('sponsors.introTitle')}
          </CustomText>
          <CustomText style={styles.marginBottom12}>
            {txt('sponsors.introBody')}
          </CustomText>

          <CustomText font={'bold'} style={styles.marginBottom12}>
            {txt('sponsors.moreInfo')}
          </CustomText>

          <View style={styles.employeeContainer}>
            <View>
              <ImageHighlight
                source={{
                  uri: 'https://filer.boblberg.dk/Assets/Img/employees/Rasmus.jpg',
                }}
              />
            </View>

            <View style={styles.employeeTextContainer}>
              <CustomText font={'bold'}>
                {txt('aboutUs.rasmusName')}
              </CustomText>
              <View>
                <CustomText text={txt('aboutUs.rasmusPosition')} />
              </View>
              <View style={[styles.containerRow, styles.marginTop12]}>
                <NormalIcon
                  name={IconNames.emailSymbol}
                  accessibilityLabel={txt('sponsors.emailIcon')}
                  size={Fontsizes.l}
                  color={Colors.text}
                  style={styles.icon}
                />
                <CustomPressable onPress={() => Linking.openURL(`mailto:${txt('aboutUs.rasmusMail')}`)}>
                  <CustomText style={{ color: Colors.blue }}>
                    {txt('aboutUs.rasmusMail')}
                  </CustomText>
                </CustomPressable>
              </View>
            </View>
          </View>

          <CustomText style={styles.marginTop12}>
            {txt('sponsors.overview')}
          </CustomText>

          <View style={styles.imageContainer}>
            <Image
              accessibilityIgnoresInvertColors
              resizeMode={'contain'}
              source={{
                uri: 'https://filer.boblberg.dk/Assets/Img/sponsors/select.png',
              }}
              style={styles.image}
              accessible
              accessibilityRole="image"
              accessibilityLabel={txt('sponsors.selectLogo')}
            />
          </View>
        </View>
      </ScrollView>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    ...SpacingStyles.marginRightLeft10,
    alignSelf: 'center',
    maxWidth: Layout.maxFeedWidth,
  },
  containerRow: { flexDirection: 'row' },
  employeeContainer: { alignItems: 'center', flexDirection: 'row', margin: 10 },
  employeeTextContainer: { flexGrow: 1, flex: 1, marginLeft: 10 },
  icon: {
    marginRight: 6,
  },
  image: {
    height: 200,
    width: 200,
  },
  imageContainer: {
    alignSelf: 'center',
    margin: 30,
  },
  marginBottom12: { marginBottom: 12 },
  marginTop12: { marginTop: 12 },
  scrollContainer: { backgroundColor: Colors.background, flex: 1 },
})
